/* Decottaa teması – ikili slider (ana sayfa). */
(() => {
  const theme = window.theme || {};
  if (!theme.utils) return;
  const { $, $$ } = theme.utils;

  /* ---------- İkili slider ---------- */
  class SplitSlider extends HTMLElement {
    connectedCallback() {
      this.slides = $$('[data-slide]', this);
      this.dots = $$('[data-slide-dot]', this);
      this.count = $('[data-slide-count]', this);
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.interval = Number(this.dataset.interval) || 6000;
      if (this.slides.length < 2) return;
      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-slide-dot]');
        if (event.target.closest('[data-slide-prev]')) this.go(this.index - 1);
        else if (event.target.closest('[data-slide-next]')) this.go(this.index + 1);
        else if (dot) this.go(Number(dot.dataset.slideDot));
        else return;
        if (!this.keyboardFocus) this.start(); // dokunup geçince otomatik geçiş baştan sayar, durmaz
      });
      // Dokunmatik kaydırma: yatay hareket 40 px'i geçerse önceki/sonraki slayt
      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        this.swipe = { x: event.clientX, y: event.clientY };
      });
      this.addEventListener('pointerup', (event) => {
        if (!this.swipe) return;
        const dx = event.clientX - this.swipe.x;
        const dy = event.clientY - this.swipe.y;
        this.swipe = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        this.go(this.index + (dx < 0 ? 1 : -1));
        this.start();
      });
      this.addEventListener('pointercancel', () => (this.swipe = null));
      // Otomatik geçiş yalnız klavyeyle slider içinde gezinirken durur (dokunma/tıklama odağı durdurmaz)
      this.addEventListener('focusin', (event) => {
        if (!event.target.matches(':focus-visible')) return;
        this.keyboardFocus = true;
        this.stop();
      });
      this.addEventListener('focusout', (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.keyboardFocus = false;
        this.start();
      });
      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    go(next) {
      const total = this.slides.length;
      this.index = (next + total) % total;
      // Slaytlar üst üste durur; görünmeyenler erişilemez (inert), geçiş CSS'te yumuşak (opaklık + hafif yakınlaşma)
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === this.index);
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.count) {
        const pad = (n) => String(n).padStart(2, '0');
        this.count.textContent = `${pad(this.index + 1)} / ${pad(total)}`;
      }
    }

    start() {
      if (this.dataset.autoplay !== 'true') return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      clearInterval(this.timer);
    }

    selectBlock(blockElement) {
      const index = this.slides.indexOf(blockElement);
      if (index > -1) {
        this.stop();
        this.go(index);
      }
    }
  }
  if (!customElements.get('split-slider')) customElements.define('split-slider', SplitSlider);


  document.addEventListener('shopify:block:select', (event) => {
    const slider = event.target.closest('split-slider');
    if (slider) slider.selectBlock(event.target);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    event.target.closest('split-slider')?.start();
  });
})();
